<template>
  <div class="modal" tabindex="-1" :id="id">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" v-html="title"></h2>
        </div>
        <div class="modal-body"><slot></slot></div>
        <div class="modal-footer">
          <button type="button" class="govuk-button mt--24" @click="closeModal()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    id: String,
    title: String,
  },

  methods: {
    closeModal() {
      this.$parent.modalActive = false;
    },
  },
};
</script>